import { EventTypeEnum, EventVm, MatchDetailVm } from '../../../../utils/api';
import MatchTeamYellowRow from './MatchTeamYellowRow';

interface OwnProps {
    match?: MatchDetailVm;
    events: EventVm[];
    isHomeTeam: boolean;
    initEvent: (type: EventTypeEnum, eventTypeValues?: any) => void;
    activeEvent?: any;
}

export type Props = OwnProps;

export default MatchTeamYellowRow;
